import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, ReplaySubject } from 'rxjs';

import {
  ApiClientService,
  ApiResponse
} from '../../shared/services/api-client.service';
import { AB_API_REFERENCE_CODES } from '../../shared/constants';
import TRANSFER_TYPE from './../enums/transfer-type';
import { IPortfolio } from './../../shared/services/portfolio.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { IBaseAccount } from './to-accounts.service';

interface ReferenceCodesResponse extends ApiResponse {}

enum PAYMENT_TYPES {
  domesticTransfer = 'Domestic',
  internationalTransfer = 'International'
}

@Injectable({
  providedIn: 'root'
})
export class ReferenceCodesService extends ApiClientService {
  private cache: { [name: string]: ReplaySubject<ReferenceCodesResponse> } = {};

  constructor(http: HttpClient) {
    super(http, AB_API_REFERENCE_CODES);
  }

  getAll(
    transferType: TRANSFER_TYPE,
    bankAccount: IBaseAccount
  ): Observable<any> {
    let params = {};

    if (PAYMENT_TYPES[TRANSFER_TYPE[transferType]]) {
      params['request.paymentType'] =
        PAYMENT_TYPES[TRANSFER_TYPE[transferType]];
    }

    if (bankAccount && bankAccount.accountNumber) {
      params['request.beneficiaryAccountNumber'] = bankAccount.accountNumber;
    }

    const stringParams = JSON.stringify(params);

    if (!this.cache[stringParams]) {
      this.cache[stringParams] = new ReplaySubject<ReferenceCodesResponse>();
      this.get(params)
        .pipe(
          debounceTime(500),
          distinctUntilChanged()
        )
        .subscribe(response => this.cache[stringParams].next(response));
    }

    return this.cache[stringParams];
  }

  showCategory(transferType: TRANSFER_TYPE, portfolio: IPortfolio): boolean {
    if (
      transferType === TRANSFER_TYPE.default ||
      transferType === TRANSFER_TYPE.internalTransfer
    ) {
      return false;
    }

    if (
      (transferType === TRANSFER_TYPE.domesticTransfer ||
        transferType === TRANSFER_TYPE.billPayee) &&
      portfolio.isResident === true
    ) {
      return false;
    }

    return true;
  }

  format(response: any) {
    let categoryNames = [];
    return response
      .map((category, index) => {
        return {
          id: index + 1,
          code: category.code,
          category: category.category,
          isDefault: category.defaultReferenceCode,
          subcategory: response
            .filter(subcategory => {
              return subcategory.category === category.category;
            })
            .map(subcategory => {
              return {
                id: subcategory.id,
                code: subcategory.code,
                name: subcategory.subCategory,
                isDefault: subcategory.defaultReferenceCode,
                explanation: subcategory.explanation
              };
            })
        };
      })
      .filter((category, index, self) => {
        if (categoryNames.indexOf(category.category) === -1) {
          categoryNames.push(category.category);
          return true;
        }

        return false;
      });
  }
}

export { PAYMENT_TYPES, ReferenceCodesResponse };
